import React from 'react';
import { Control, useWatch } from 'react-hook-form';
import { camelCase } from 'lodash';

import { Question, Section } from './data';

interface DynamicFormSectionProps {
  section: Section;
  control: Control;
}

function calculateScore(values: Record<string, string>, questions: Array<Question>) {
  if (!values) return 0;

  let score = 0;

  Object.keys(values).forEach((key) => {
    if (values[key] === 'yes') {
      const question = questions.find((q) => (camelCase(q.label) === key));
      if (question) score += question.score;
    }
  });

  return score;
}

export default function DynamicFormSectionScore({ section, control }: DynamicFormSectionProps) {
  // If scored, calculate total
  const { total, enabled } = React.useMemo(() => {
    const t = section.questions
      .map((question) => (question.score || 0))
      .reduce((accumulator, current) => (accumulator + current));

    return { total: t, enabled: t > 0 };
  }, [section]);

  // Watch the form for value updates
  const watch = useWatch({ control, disabled: !enabled, name: camelCase(section.label) });

  // Calculate the current score
  const score = React.useMemo(() => (
    calculateScore(watch, section.questions)
  ), [watch, section.questions]);

  if (!enabled) return null;

  return (
    <span>{`${score} / ${total} (${Math.round((score / total) * 100)}%)`}</span>
  );
}
